import { render } from "./examination.vue?vue&type=template&id=1132741a&scoped=true"
import script from "./examination.vue?vue&type=script&lang=js"
export * from "./examination.vue?vue&type=script&lang=js"

import "./examination.vue?vue&type=style&index=0&id=1132741a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1132741a"

export default script